import React from 'react';
import ClientsPoliciesLayout from './clients-policies-layout';

export default class ClientsPolicies extends React.Component<{}, {}> {
    render(){
        return(
            <ClientsPoliciesLayout/>
        )
    }
}